import { pusherKey, pusherCluster, backendUrl } from '../app-globals';
import Pusher from 'pusher-js';
import Vue from 'vue';
import store from '../store';
import constants from '../constants';

const userData = store.getters.getUser;
const organization = userData.user.organization;

// create pusher instance
const pusher = new Pusher(pusherKey, {
    cluster: pusherCluster,
    wssPort: 443,
    enabledTransports: ['ws'],
    forceTLS: true,
    encrypted: true,
    auth: {
        headers: {
            Authorization: `Bearer ${userData.token}`,
        },
    },
    authEndpoint: `${backendUrl}/api/broadcasting/auth`,
});

Vue.prototype.$pusher = pusher;

// organization channel
var organizationChannel = pusher.subscribe(`${constants.SOCKET_ORGANIZATION_CHANNEL}.${organization.external_id}`);

organizationChannel.bind(`${constants.SOCKET_SEND_ALERT_MESSAGE}`, (e) => {
    store.dispatch('widgets/fetchAlertHistories', e);
    store.dispatch('notifications/recordMessage', e);
});
organizationChannel.bind(`${constants.SOCKET_RECEIVE_ALERT_RESPONSE}`, (e) => {
    store.dispatch('widgets/addResponseStatus', e);
});

export default pusher;
